import styled from '@emotion/styled';
import { WarningRounded } from '@mui/icons-material';
import type { FallbackRender } from '@sentry/react';

export const GenericErrorFallback: FallbackRender = ({ error, resetError }) => {
  const errorObj = error as object;

  return (
    <FallbackPage role="alert">
      <FallbackPanel>
        <WarningRounded fontSize="large" />
        <h1>Something went wrong</h1>
        {'message' in errorObj ? <Pre>{errorObj.message as string}</Pre> : null}
        <Actions>
          <button type="button" onClick={resetError}>
            Try again
          </button>
          <button type="button" onClick={() => window.location.reload()}>
            Reload
          </button>
        </Actions>
      </FallbackPanel>
    </FallbackPage>
  );
};

const FallbackPage = styled.main`
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 24px;
  background: var(--walky-bg, #f6f6f7);
  color: var(--walky-ink, #1f1f21);
`;

const FallbackPanel = styled.section`
  width: min(520px, 100%);
  display: grid;
  justify-items: center;
  gap: 18px;
  padding: 36px;
  border: 1px solid var(--walky-border, #e2e2e4);
  border-top: 4px solid var(--walky-orange, #f45a0a);
  border-radius: 8px;
  background: var(--walky-surface, #ffffff);
  box-shadow: var(--walky-shadow, 0 18px 38px rgba(31, 31, 33, 0.12));
  text-align: center;

  svg {
    color: var(--walky-orange, #f45a0a);
  }

  h1 {
    margin: 0;
    font-size: 28px;
    line-height: 1.1;
  }
`;

const Pre = styled.pre`
  width: 100%;
  max-height: 180px;
  overflow: auto;
  margin: 0;
  padding: 14px;
  border-radius: 8px;
  background: var(--walky-surface-raised, #f0f0f2);
  color: var(--walky-ink-muted, #555a63);
  text-align: left;
  white-space: pre-wrap;
`;

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;

  button {
    min-width: 128px;
    min-height: 44px;
    border: 0;
    border-radius: 8px;
    background: var(--walky-orange, #f45a0a);
    color: white;
    font-weight: 700;
    cursor: pointer;
  }
`;
